(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-media-gallery"] && !Shopify.designMode) return;
  try {
    /* CHIVAS : préserver la navigation manuelle du carrousel */

  document.addEventListener('click', function(event) {

    const arrow = event.target.closest(
      'product-card-media-gallery .splide__arrow'
    );

    if (!arrow) return;

    const gallery = arrow.closest(
      'product-card-media-gallery'
    );

    if (gallery) {
      gallery.setAttribute('data-chivas-manual', '');
    }

  }, true);

  document.addEventListener('pointerleave', function(event) {

    const card = event.target;

    if (!card.matches || !card.matches('product-card')) {
      return;
    }

    const gallery = card.querySelector(
      'product-card-media-gallery[data-chivas-manual]'
    );

    if (gallery) {
      gallery.removeAttribute('data-chivas-manual');
    }

  }, true);
  } catch(e) { console.error(e); }
})();

})();
